import React from "react";
import { any, bool, string } from "prop-types";
import { useFormContext } from "react-hook-form";
import _ from "lodash";
import { Stack } from "@bedrock-layout/stack";
import { Text } from "theme-ui";

import InputFactory from "./InputFactory";

function InputField({
    label,
    name,
    type = "text",
    disabled = false,
    variant,
    required = true,
    ...rest
}) {
    const { register, formState, getValues } = useFormContext();
    const error = _.get(formState.errors, name);

    return (
        <InputFactory
            type={type}
            disabled={disabled}
            defaultValue={getValues(name)}
            error={error}
            label={label}
            variant={variant}
            name={name}
            register={register}
            {...rest}
        />
    );
}

InputField.propTypes = {
    label: string,
    type: string,
    required: bool,
    disabled: bool,
    rest: any,
    name: string,
    variant: string,
    readOnly: bool,
};

export default InputField;
